export function capitalizeName(name) {
	if (!name) return '';

	const words = name.split(/(\s+)/);

	return words.map((word) => {
		if (/^\s+$/.test(word)) {
			return word;
		}
		if (word.length > 0) {
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		}
		return word;
	}).join('');
}

export function validateName(name, t) {
	if (!name || !name.trim()) return { isValid: false, error: t('clients.validation.nameRequired') };

	const nameRegex = /^[a-zA-ZÀ-ÿĀ-ſƀ-ɏ\s'-]+$/u;
	if (!nameRegex.test(name.trim())) {
		return { isValid: false, error: t('clients.validation.nameInvalid') };
	}

	return { isValid: true, error: '' };
}

export function validatePhone(phone, t) {
	if (!phone || !phone.trim()) return { isValid: true, error: '' };

	const cleanPhone = phone.replace(/[\s\-()+]/g, '');

	if (!/^\d+$/.test(cleanPhone)) {
		return { isValid: false, error: t('clients.validation.phoneInvalid') };
	}

	if (cleanPhone.length < 7 || cleanPhone.length > 15) {
		return { isValid: false, error: t('clients.validation.phoneTooShort') };
	}

	return { isValid: true, error: '' };
}

export function validatePID(pid, t) {
	if (!pid || !pid.trim()) return { isValid: true, error: '' };

	if (!/^\d+$/.test(pid.trim())) {
		return { isValid: false, error: t('clients.validation.pidInvalid') };
	}

	if (pid.trim().length < 3) {
		return { isValid: false, error: t('clients.validation.pidTooShort') };
	}

	return { isValid: true, error: '' };
}

export function validateEmail(email, t) {
	if (!email || !email.trim()) return { isValid: false, error: t('clients.validation.emailRequired') };

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailRegex.test(email.trim())) {
		return { isValid: false, error: t('clients.validation.emailInvalid') };
	}

	return { isValid: true, error: '' };
}

export function validateCompanyRegCode(regCode, t) {
	if (!regCode || !regCode.trim()) return { isValid: true, error: '' };

	if (!/^\d+$/.test(regCode.trim())) {
		return { isValid: false, error: t('clients.validation.regCodeInvalid') };
	}

	if (regCode.trim().length < 3) {
		return { isValid: false, error: t('clients.validation.regCodeTooShort') };
	}

	return { isValid: true, error: '' };
}

export function clientToForm(client) {
	if (!client) {
		return {
			firstname: '',
			lastname: '',
			email: '',
			phone: '',
			pid: '',
			type: 'person',
			business_name: '',
			business_address: '',
			business_reg_code: '',
		};
	}

	return {
		firstname: client.firstname || '',
		lastname: client.lastname || '',
		email: client.email || '',
		phone: client.phone || '',
		pid: client.pid || '',
		type: client.type || 'person',
		business_name: client.business_name || '',
		business_address: client.business_address || '',
		business_reg_code: client.business_reg_code || '',
	};
}
